var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#1D2933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2096 7.59054C14.4268 8.07967 12.9232 10.2896 11.602 11.6108C10.2809 12.932 8.07093 14.4356 7.5818 14.2183C6.97039 13.9468 5.62608 11.5829 5.02132 11.6579C4.41655 11.7329 0.559611 13.824 0.566252 14.1705C0.572894 14.517 0.384389 18.2372 5.32409 18.4185C9.15207 18.559 13.6088 14.1934 13.8842 13.9198L13.9111 13.8929C14.1847 13.6175 18.5502 9.16081 18.4097 5.33282C18.2285 0.393127 14.5083 0.581632 14.1617 0.574991C13.8152 0.568348 11.7241 4.42529 11.6491 5.03006C11.5741 5.63482 13.9381 6.97913 14.2096 7.59054Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.375e0ce1be6af33807b578b966b55da2.svg";
export { ForwardRef as ReactComponent };